import {BaseVueEntity} from "@/entities/BaseVueEntity";
import {isDefined} from "@/utils";
import Stand from "@/entities/Stand";
import {Exhibitor} from "@/entities/Exhibitor";
import {Image} from '@/entities/Image';


export class Product extends BaseVueEntity {


  private readonly _info: string;
  private readonly _name: string;
  private readonly _themes: string[];
  private readonly _themesDisplay: string[];
  private readonly _sortOrder: string;
  private readonly _stand: string;
  private readonly _hall: string;
  private readonly _stands: Stand[];
  private readonly _logo: string;
  private readonly _companyId: string;
  private readonly _subTitle: string;
  private readonly _images: Image[];

//TODO
  public _logoPath: string;

  private _exhibitor: Exhibitor;

  constructor(entity, logoPath: string, picturePath: string) {
    super();

    this._info = entity.INFO;
    this._name = entity.TITEL;
    this._themes = entity.THEMEN;
    this._logo = entity.LOGO;
    this._themesDisplay = entity.THEMEN_ANZEIGE;
    this._sortOrder = entity.S_ORDER;
    this._stand = entity.STAND;
    this._hall = entity.HALLE;
    this._companyId = entity.FIRMA_ID;
    this._subTitle = entity.UNTERTITEL;

    if (isDefined(entity.STAENDE)) {
      this._stands = entity.STAENDE.map(e => new Stand(e));
    }

    if (isDefined(entity.BILDER)) {
      const images: Image[] = [];
      const imageNames: string[] = (entity.BILDER as string).split('|');
      let imageVersions: string[] = [];
      let imageTexts: string[] = [];
      if (isDefined(entity.BILDER_VERSIONEN)) {
        imageVersions = (entity.BILDER_VERSIONEN as string).split('|');
      }
      if (isDefined(entity.BILDER_TEXTE)) {
        imageTexts = (entity.BILDER_TEXTE as string).split('|');
      }

      imageNames.forEach((name, index) => {
        let version: string = undefined;
        let text: string = undefined;
        if (imageVersions[index] !== undefined) {
          version = imageVersions[index];
        }
        if (imageTexts[index] !== undefined) {
          text = imageTexts[index];
        }
        images.push(new Image(picturePath, name, version, text));
      });
      this._images = images;
    }

    this._logoPath = logoPath;
  }


  public getLogoUrl(): string {
    return process.env.VUE_APP_BACKEND_URL + '/' + this._logoPath + this._logo;
  }

  public getFirstImage(): Image | undefined {
    if (this._images === undefined) {
      return undefined;
    }
    return this._images[0];
  }

  public hasSearchValue(value: string): boolean {
    for (const prop of ['_name', '_subTitle']) {
      if (isDefined(this[prop]) && this[prop].toLowerCase().indexOf(value) > -1) {
        return true;
      }
    }
    return false;
  }

  public getFirstLetter(): string {
    return this._name.charAt(0).toUpperCase();
  }

  get name(): string {
    return this._name;
  }

  get logo(): string {
    return this._logo;
  }


  get info(): string {
    return this._info;
  }

  get themes(): string[] {
    return this._themes;
  }


  get themesDisplay(): string[] {
    return this._themesDisplay;
  }

  get sortOrder(): string {
    return this._sortOrder;
  }


  get stands(): Stand[] {
    return this._stands;
  }


  get stand(): string {
    return this._stand;
  }

  get companyId(): string {
    return this._companyId;
  }


  get exhibitor(): Exhibitor {
    return this._exhibitor;
  }

  set exhibitor(value: Exhibitor) {
    this._exhibitor = value;
  }


  get subTitle(): string {
    return this._subTitle;
  }


  get images(): Image[] {
    return this._images;
  }
}
